<template>
    <BasePanel
        headline="lang_CONTRACTS_LABEL_PANEL_CAPTION_ADVANCE"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                hide-default-footer
                :items-per-page="300"
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
            >
            <!-- TOP SLOT -->
                <template v-slot:top>
                    <v-row class="pb-3">
                        <v-spacer></v-spacer>
                        <v-col 
                            cols="3"
                            align-self="end"
                        >
                            <BaseButton 
                                @click="addNewRow"
                                :disabled="$route.params.alvId === 'new'"
                                label="lang_GENERAL_BUTTON_ADD_ROW"
                                block
                                :alvqa="alvqa + '-button-add-row'"
                            />
                        </v-col>
                    </v-row>
                </template>

            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- Items -->
                <template v-slot:[`item.clearanceOfAdvances`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-clearance-of-advances'">
                        {{ item.clearanceOfAdvances }}
                    </div>
                </template>
                <template v-slot:[`item.enteredBy`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-entered-by'">
                        {{ item.enteredBy }} 
                        {{ $t('lang_GENERIC_CAPTION_ON') }} 
                        {{ item.enteredOn !== null ? $d(new Date(item.enteredOn), 'alvDateTime') : ''}}
                    </div>
                </template>
                <template v-slot:[`item.entered`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-entered'">
                        {{ getEnteredTranslation(item.entered) }}
                    </div>
                </template>
                <template v-slot:[`item.credit`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa + '-list-row-text-credit'"
                    >
                        {{ $n(item.credit, 'number') }}
                    </div>
                </template>
                <template v-slot:[`item.balance`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa + '-list-row-text-balance'"
                    >
                        {{ $n(item.balance, 'number') }}
                    </div>
                </template>

            <!-- Buttons -->
                <template v-slot:[`item.inlineEdit`]="{ item }">
                    <BaseIcon   
                        :alvqa="alvqa + '-list-row-icon-inline-edit'"
                        icon="edit" 
                        tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"   
                        @click.stop="editInlineFunction(item)"
                    />
                </template>
                <template v-slot:[`item.delete`]="{ item }">
                    <BaseIcon 
                        @click="deleteRow(item)"
                        icon="delete"
                        color="iconDelete"
                        tooltipText="lang_GENERIC_CAPTION_DELETE"
                        :alvqa="alvqa + 'list-row-icon-delete'"
                    />
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from '@/components/_buttons/BaseIcon'

export default {
    name: "LabelContractsAdvanceEditPanel",
    components: {
        BasePanel,
        BaseButton,
        BaseIcon
    },
    data() {
        return {
            alvqa: 'contracts-label-edit-form-panel-advance'
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t("lang_LABEL_CONTRACTS_ADVANCE_CLEARANCE"), 
                    align: "left", 
                    value: "clearanceOfAdvances",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-clearance-of-advances'
                },
                {
                    text: this.$t("lang_LABEL_CONTRACTS_ADVANCE_ENETERED_BY"), 
                    align: "left", 
                    value: "enteredBy",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-entered-by'
                },
                {
                    text: this.$t("lang_LABEL_CONTRACTS_ADVANCE_ENETERED"), 
                    align: "left", 
                    value: "entered",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-entered'
                },
                {
                    text: this.$t("lang_LABEL_CONTRACTS_ADVANCE_CREDIT") + ' ' + this.$store.getters.getSelectedCurrency, 
                    align: "right", 
                    value: "credit",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-credit'
                },
                {
                    text: this.$t("lang_LABEL_CONTRACTS_ADVANCE_BALANCE") + ' ' + this.$store.getters.getSelectedCurrency, 
                    align: "right", 
                    value: "balance",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-balance'
                },
                {
                    text: '', 
                    value: 'inlineEdit',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
                },
                {
                    text: "",
                    align: "right",
                    width: "70px",
                    value: "delete",
                    sortable: false,
                    class: 'text-no-wrap'
                }
            ]
        },
        listItems() { return this.$store.getters.getLabelContractsAdvance }
    },
    methods: {
        getEnteredTranslation(enteredValue) {
            if(enteredValue === 'manual') return this.$t('lang_GENERIC_CAPTION_MANUAL')
            if(enteredValue === 'automatic') return this.$t('lang_GENERIC_CAPTION_AUTOMATIC')
        },
        addNewRow() {
            this.$store.commit('setSelectedLabelContractsAdvance', [])
            this.$store.commit('setShowLabelContractsAdvanceEditingDialog', true)
            this.$store.commit('setEditingDialogHeadline', this.$t('lang_GENERAL_CAPTION_NEW_ENTRY'))

            let defaultValues = JSON.parse(JSON.stringify(this.$store.getters.getDefaultLabelContractsAdvance)) 
            this.$store.commit('setLabelContractsAdvanceEditingDialogDetails', defaultValues)
        },
        editInlineFunction(item) {
            this.$store.commit('setSelectedLabelContractsAdvance', item.id)
            let detailsDeepCopy = JSON.parse(JSON.stringify(item))

            detailsDeepCopy['credit'] = this.$n(detailsDeepCopy['credit'], 'number')

            // set the copy in dialog details to edit
            this.$store.commit('setLabelContractsAdvanceEditingDialogDetails', detailsDeepCopy)
            this.$store.commit('setEditingDialogHeadline', this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY")) // set headline
            this.$store.commit('setShowLabelContractsAdvanceEditingDialog', true) 
        },
        deleteRow(item) {
            // set the selected row that should be deleted from the delete action 
            // and open the deletion dialog
            this.$store.commit("setSelectedLabelContractsAdvance", item)
            this.$store.commit('setDeletionDialogContext', 'SelectedLabelContractsAdvance')
            this.$store.commit('setShowDeletionDialog', true)
        },
    }
}
</script>
